import { Box, Paper } from '@mui/material';
import BandList from '../BandList/BandList';
import EnhancedQueue from '../Player/EnhancedQueue';
import FavoritesList from '../Favorites/FavoritesList';

interface MobileLayoutProps {
  activeTab: number;
}

const MobileLayout = ({ activeTab }: MobileLayoutProps) => {
  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return <BandList />;
      case 1:
        return <EnhancedQueue />;
      case 2:
        return <FavoritesList />;
      default:
        return <BandList />;
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        overflow: 'auto',
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          height: '100%',
          width: '100%',
          borderRadius: 0,
          overflow: 'auto',
        }}
      >
        {renderContent()}
      </Paper>
    </Box>
  );
};

export default MobileLayout;
